import { useMutation } from '@apollo/client';
import { UPDATE_REPORT_VERSION_MUTATION } from '../operations';

export const useUpdateReportVersion = () => {
  const [updateReportVersionMutation, { data, loading, error }] = useMutation(
    UPDATE_REPORT_VERSION_MUTATION,
  );

  const updateReportVersion = async (reportVersion) => {
    if (!reportVersion) throw new Error('No report version found to update');

    // Ensure the pages are in the correct format
    const pages = reportVersion.pages.map((page) => ({
      layout: page.layout || 'default',
      thumbnailUrl: page.thumbnailUrl,
      description: page.description,
      number: page.number,
      pageElements:
        page.pageElements?.map((element) => ({
          componentId: element.componentId,
          slotId: element.slotId,
          style: element.style,
          payload: element.payload,
          data: element.data,
        })) || [],
    }));

    await updateReportVersionMutation({
      variables: {
        id: reportVersion.id,
        input: { pages },
      },
    });
  };

  return {
    updateReportVersion,
    updatedReportVersion: data?.updateSmartReportVersion || null,
    loading,
    error,
  };
};
